import l from "react";
var d = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, f = l.createContext && l.createContext(d), c = function() {
  return c = Object.assign || function(t) {
    for (var r, e = 1, n = arguments.length; e < n; e++) {
      r = arguments[e];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, c.apply(this, arguments);
}, v = function(t, r) {
  var e = {};
  for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && r.indexOf(n) < 0 && (e[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(t); a < n.length; a++)
    r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[a]) && (e[n[a]] = t[n[a]]);
  return e;
};
function m(t) {
  return t && t.map(function(r, e) {
    return l.createElement(r.tag, c({
      key: e
    }, r.attr), m(r.child));
  });
}
function o(t) {
  return function(r) {
    return l.createElement(h, c({
      attr: c({}, t.attr)
    }, r), m(t.child));
  };
}
function h(t) {
  var r = function(e) {
    var n = t.attr, a = t.size, u = t.title, g = v(t, ["attr", "size", "title"]), s = a || e.size || "1em", i;
    return e.className && (i = e.className), t.className && (i = (i ? i + " " : "") + t.className), l.createElement("svg", c({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, e.attr, n, g, {
      className: i,
      style: c(c({
        color: t.color || e.color
      }, e.style), t.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), u && l.createElement("title", null, u), t.children);
  };
  return f !== void 0 ? l.createElement(f.Consumer, null, function(e) {
    return r(e);
  }) : r(d);
}
function w(t) {
  return o({ tag: "svg", attr: { viewBox: "0 0 640 512" }, child: [{ tag: "path", attr: { d: "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z" } }] })(t);
}
function O(t) {
  return o({ tag: "svg", attr: { viewBox: "0 0 320 512" }, child: [{ tag: "path", attr: { d: "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z" } }] })(t);
}
function x(t) {
  return o({ tag: "svg", attr: { viewBox: "0 0 320 512" }, child: [{ tag: "path", attr: { d: "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z" } }] })(t);
}
export {
  x as F,
  o as G,
  O as a,
  w as b
};
